module.exports = __webpack_public_path__ + "img/horizontal_3_2_9006.54d9d6cf.png";